import { render, staticRenderFns } from "./DashboardAgentSegmentPopup.vue?vue&type=template&id=0a42fe5e"
import script from "./DashboardAgentSegmentPopup.vue?vue&type=script&lang=js"
export * from "./DashboardAgentSegmentPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports